module.exports = __webpack_public_path__ + "hashtag-2.ca71b74a67e768862ebff7e84f20cedd.svg";